<template>
  <div class="gewerbe-vorversicherungen mb-n4">
    <v-row no-gutters>
      <v-col cols="12"
             sm="7"
             class="pr-6 mb-4">
        <div class="dmb-form-text pt-1">Bestanden/bestehen für {{ article }} <strong>{{ label }}</strong> andere Rechtsschutz-Versicherungen 
        mit vergleichbarem Versicherungsumfang?*</div>
      </v-col>
      <v-col cols="12"
             sm="5">
        <v-radio-group v-model="hasVV"
                       v-validate.disable="'required'"
                       :error-messages="errors.collect('hasvorversicherung')"
                       data-vv-as="Vorversicherungen"
                       data-vv-name="hasvorversicherung"
                       name="hasvorversicherung"
                       row>
          <v-radio label="Ja"
                   :value="true"
                   color="primary" />
          <v-radio label="Nein"
                   :value="false"
                   color="primary" />
        </v-radio-group>
      </v-col>

    <v-col v-if="hasVV"
           cols="12" >
      <template v-for="(versicherung, index) of versicherungen">
        <gewerbe-vorversicherung :key="'vv_' + personRef + '_' + index"
                                 :state-path="statePath + '.versicherungen.' + index"
                                 :index="index"
                                 :remove="index > 0 && index === versicherungen.length - 1"
                                 :class="{ 'mt-4': index > 0, 'mb-6': index === 2 }"
                                 @remove="removeVorVers" />
      </template>

      <add-button v-if="versicherungen.length < 3"
                  text="Vorversicherung hinzufügen"
                  class="mb-6"
                  @add="addVorVers">
      </add-button>
    </v-col>


      <v-col cols="12"
             sm="7"
             class="pr-6 mb-4">
        <div class="dmb-form-text pt-1">Rechtsstreitigkeiten in den letzten 5 Jahren*</div>
      </v-col>
      <v-col cols="12"
             sm="5">
        <v-radio-group v-model="hasStreit"
                       v-validate.disable="'required'"
                       :error-messages="errors.collect('hasRechtsstreitigkeiten')"
                       data-vv-as="Rechtsstreitigkeiten"
                       data-vv-name="hasRechtsstreitigkeiten"
                       name="hasRechtsstreitigkeiten"
                       row>
          <v-radio label="Ja"
                   :value="true"
                   color="primary" />
          <v-radio label="Nein"
                   :value="false"
                   color="primary" />
        </v-radio-group>
      </v-col>

      <template v-if="hasStreit">
        <v-col cols="0"
                  sm="7" />
        <v-col cols="12"
              sm="5">
          <v-text-field v-model="anzahlrechtsstreitigkeiten"
                        v-validate="'required|numeric|min_value:1|max_value:9999'"
                        :error-messages="errors.collect('anzahlRechtsstreitigkeiten')"
                        data-vv-as="Anzahl Rechtsstreitigkeiten"
                        data-vv-name="anzahlRechtsstreitigkeiten"
                        label="Anzahl Rechtsstreitigkeiten"
                        class="required" />
        </v-col>

        <v-col cols="0"
                  sm="7" />
        <v-col cols="12"
              sm="5">
          <v-text-field v-model="leistungshoeherechtsstreitigkeiten"
                        v-validate="{ required: true,
                                      numeric: true,
                                      max_value:99900,
                                      rounded: true }"
                        data-vv-validate-on="change"
                        :error-messages="errors.collect('leistungshoeheRechtsstreitigkeiten')"
                        data-vv-as="Leistung des Vorversicherers (auf volle 100 Euro gerundet)"
                        suffix="€"
                        class="required"
                        persistent-hint
                        hint="auf volle 100 Euro aufgerundet"
                        name="leistungshoeheRechtsstreitigkeiten"
                        label="Leistung des Vorversicherers"
                        @input="watchInput('leistungshoeheRechtsstreitigkeiten')" />
        </v-col>
      </template>

      <v-col v-if="!isCompany"
               cols="12"
               sm="7"
               class="pr-6 mb-4">
          <div class="dmb-form-text pt-1">Zusätzliche Anwaltsbesuche in den letzten 5 Jahren*</div>
        </v-col>
        <v-col v-if="!isCompany"
               cols="12"
               sm="5">
          <v-radio-group v-model="hasAnwalt"
                         v-validate.disable="'required'"
                         :error-messages="errors.collect('hasAnwaltsbesuche')"
                         data-vv-as="Anwaltsbesuche"
                         data-vv-name="hasAnwaltsbesuche"
                         name="hasAnwaltsbesuche"
                         row>
            <v-radio label="Ja"
                     :value="true"
                     color="primary" />
            <v-radio label="Nein"
                     :value="false"
                     color="primary" />
          </v-radio-group>
        </v-col>

      <template v-if="hasAnwalt">
        <v-col cols="0"
                  sm="7" />
        <v-col cols="12"
               sm="5">
          <v-text-field v-model="anzahlanwaltsbesuche"
                        v-validate="'required|numeric|min_value:1|max_value:9999'"
                        :error-messages="errors.collect('anzahlAnwaltsbesuche')"
                        data-vv-as="Anzahl Anwaltsbesuche"
                        data-vv-name="anzahlAnwaltsbesuche"
                        label="Anzahl Anwaltsbesuche"
                        class="required" />
        </v-col>
      </template>

      <v-col cols="12"
             sm="7"
             class="pr-6 mb-4">
        <div class="dmb-form-text pt-1">Läuft aktuell ein strafrechtliches Ermittlungsverfahren gegen {{ gegen }}?*</div>
      </v-col>
      <v-col cols="12"
             sm="5">
        <v-radio-group v-model="streitaktuell"
                       v-validate="'required'"
                       :error-messages="errors.collect('streitAktuell')"
                       data-vv-as="Aktuelle Ermittlungsverfahren"
                       data-vv-name="streitAktuell"
                       required
                       row
                       class="mb-0 pb-0">
          <v-radio label="Ja"
                   value="J"
                   color="primary" />
          <v-radio label="Nein"
                   value="N"
                   color="primary" />
        </v-radio-group>
      </v-col>

    </v-row>
  </div>
</template>

<script>
import ValidationMixin from "@/components/helper/ValidationMixin";
import {mapTwoWay} from "@/store/twowayBindingMixin";
import twowayBinding from "@/store/twowayBindingMixin";
import GewerbeVorversicherung from './GewerbeVorversicherung';
import AddButton from './AddButton';

export default {
  name: "GewerbeVorversicherungen",
  components: { AddButton, GewerbeVorversicherung },
  //components: { VorVersicherung },
  mixins: [ValidationMixin, twowayBinding],
  props: {
    personRef: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    gegen: {
      type: String,
      required: true
    },
    article: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapTwoWay([
      'ref',
      'anzahlrechtsstreitigkeiten',
      'leistungshoeherechtsstreitigkeiten',
      'anzahlanwaltsbesuche',
      'leistungshoeheanwaltsbesuche',
      'streitaktuell',
      'versicherungen'
    ]),
    ...mapTwoWay([
      'hasVorversicherung',
      'hasStreitigkeiten',
      'hasAnwaltsbesuche'
    ], {}, 'gewerbe.ui'),
    hasVV: {
      get() {
        return this.hasVorversicherung[this.personRef];
      },
      set(value) {
        if (value && this.versicherungen.length === 0) this.addVorVers();
        this.$store.commit('gewerbeStep4Radios', { ref: this.personRef, type: 'hasVorversicherung', value });
        this.$validator.validate('hasvorversicherung');
      }
    },
    hasStreit: {
      get() {
        return this.hasStreitigkeiten[this.personRef];
      },
      set(value) {
        this.$store.commit('gewerbeStep4Radios', { ref: this.personRef, type: 'hasStreitigkeiten', value });
        this.$validator.validate('hasRechtsstreitigkeiten');
      }
    },
    hasAnwalt: {
      get() {
        return this.hasAnwaltsbesuche[this.personRef];
      },
      set(value) {
        this.$store.commit('gewerbeStep4Radios', { ref: this.personRef, type: 'hasAnwaltsbesuche', value });
        this.$validator.validate('hasAnwaltsbesuche');
      }
    },
    isCompany(){
      return !!(this.personRef.startsWith('vn') || this.personRef.startsWith('mvu'));
    }
  },
    created() {
    this.$validator.extend('rounded', {
      getMessage() {
        return `Wert ist nicht auf volle 100 € aufgerundet.`;
      },
      validate: function (value) {
        if( value === "" || value === null ) return true;
        if( value % 100 === 0 ) return true;
        return false;
      }.bind(this)
    });
  },
  methods: {
    removeVorVers() {
      this.$store.commit('gewerbeRemoveVorversicherung', { ref: this.ref});
    },
    addVorVers() {
      this.$store.commit('gewerbeAddVorversicherung', { ref: this.ref });
    },
    watchInput(fieldName) {
      //Standard Validation happens on blur to avoid overacting, resetting error messages and Direktionsanfrage happens on Input
      let field = this.$validator.fields.find({name:fieldName});
      
       this.$validator.validate(fieldName).then( (result) => {
          if(!result) fnError(fieldName);
        });
      
      const fnError = (function(controlname){
          const maxerror = this.errors.items.filter(
          (er) => er.rule === "max_value"
                  && er.field === controlname);
          if( maxerror.length || parseFloat(field.value) > 99900 ) {
            this.$store.dispatch('gewerbeShowDirektionsanfrage', {
              label: 'Leistungshöhe',
              limit: '99.900 €'
            });
          }
          const minerror = this.errors.items.filter(
          (er) => er.rule === "rounded"
                  && er.field === controlname);
          if( minerror.length) {
            field.reset();
            this.$validator.errors.remove(field.name, field.scope);
          }
      }).bind(this);

    }
  }
};
</script>

<style>
.gewerbe-vorversicherungen .v-input--radio-group__input .v-radio:not(:last-child) {
  margin-right: 74px!important;
}
</style>

